if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      if (this.hidden) {
        this.initLazySection();
      } else {
        window.initLazyScript(this, this.initLazySection.bind(this));
      }
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.variantInventory = this.getVariantInventory();

      const variantPicker = this.closest('.product-info').querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );
    }

    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];

        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy
        );
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    updateInventory(count, available, inventoryPolicy) {
      let inventoryLevel;

      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      // Force backorder / out-of-stock messages to show
      if (inventoryLevel === 'backordered' || inventoryLevel === 'none') {
        this.hidden = false;
        this.setAttribute('data-inventory-level', inventoryLevel);

        if (this.inventoryNotice) {
          this.inventoryNotice.innerText = '';
        }

        if (this.urgencyMessage) {
          if (inventoryLevel === 'backordered') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStockBackordered;
          } else {
            this.urgencyMessage.innerHTML = this.dataset.textNoStock;
          }
        }

        return;
      }

      if (
        this.dataset.showNotice === 'always' ||
        (this.dataset.showNotice === 'low' && inventoryLevel.includes('low'))
      ) {
        this.hidden = false;
        this.setAttribute('data-inventory-level', inventoryLevel);

        if (this.inventoryNotice) {
          if (
            inventoryLevel !== 'in_stock' &&
            (this.dataset.showCount === 'always' ||
              (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))
          ) {
            this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
          } else if (inventoryLevel === 'very_low') {
            this.inventoryNotice.innerText = theme.strings.veryLowStock;
          } else if (inventoryLevel === 'low') {
            this.inventoryNotice.innerText = theme.strings.lowStock;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.inventoryNotice.innerText = theme.strings.inStock;
          }
        }

        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          }
        }
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}